export default "__VITE_ASSET__BHf$x4Ac__"